<template>
	<div>
		<b-img src="/images/importer/module-colliders/colliders.jpg"></b-img>
		<p>
			The Colliders module currently does not have any functionality within the module itself, just some guidance for setting up colliders on your character.
		</p>
	</div>
</template>

<script>
export default {
		name: 'CollidersModule',
}
</script>
